import { useEffect, useMemo, useRef, useState } from 'react';
import { getPromotionNextBoundaryMs } from '../utils/priceListPromotions';

const MAX_TIMER_DELAY = 2147483647;

export const getPromotionClockOffsetMs = (promotionClock, localNow = Date.now()) => {
  const serverNow = promotionClock?.serverNow ?? promotionClock;
  if (serverNow === null || serverNow === undefined || serverNow === '') return 0;
  const serverNowMs = new Date(serverNow).getTime();
  const localNowMs = Number(localNow);
  if (!Number.isFinite(serverNowMs) || !Number.isFinite(localNowMs)) return 0;
  return serverNowMs - localNowMs;
};

const usePromotionClock = (promotions = [], onBoundary, promotionClock = null) => {
  const [tick, setTick] = useState(0);
  const callbackRef = useRef(onBoundary);
  callbackRef.current = onBoundary;
  const serverNow = promotionClock?.serverNow ?? null;
  const offsetMs = useMemo(
    () => getPromotionClockOffsetMs(serverNow, Date.now()),
    [serverNow]
  );
  const now = Date.now() + offsetMs;

  const nextBoundaryMs = getPromotionNextBoundaryMs(promotions, now);

  useEffect(() => {
    if (!Number.isFinite(nextBoundaryMs)) return undefined;
    const delay = Math.min(
      Math.max(nextBoundaryMs - (Date.now() + offsetMs) + 25, 0),
      MAX_TIMER_DELAY
    );
    const timer = window.setTimeout(() => {
      const nextNow = Date.now() + offsetMs;
      setTick((current) => current + 1);
      if (nextNow >= nextBoundaryMs) callbackRef.current?.(nextNow);
    }, delay);
    return () => window.clearTimeout(timer);
  }, [nextBoundaryMs, offsetMs, tick]);

  return now;
};

export default usePromotionClock;
